import { createAppAsyncThunk, logger, tap2mineReferralContract } from 'shared';
import { Address } from 'viem';

import { actionTypes } from '../action-types';
import { actions } from '../reducer';

export const getClaimableAmount = createAppAsyncThunk(
  actionTypes.GET_CLAIMABLE,
  async (address: Address, { dispatch }) => {
    try {
      const amount = await tap2mineReferralContract.read.claimable([address]);

      dispatch(actions.updateClaimableAmount(amount.toString()));

      return null;
    } catch (error) {
      logger(actionTypes.GET_CLAIMABLE, error);

      throw error;
    }
  },
);
